import { jsx, jsxs } from "react/jsx-runtime";
import { Icon, Button, KeyCombo } from "@blueprintjs/core";
import CutsiteFilter from "../CutsiteFilter";
import React from "react";
import ToolbarItem from "./ToolbarItem";
import { connectToEditor } from "../withEditorProps";
import { userDefinedHandlersAndOpts } from "../Editor/userDefinedHandlersAndOpts";
import { pick } from "lodash-es";
export default connectToEditor(
  ({ readOnly, annotationVisibility = {}, toolBar = {} }) => {
    return {
      readOnly,
      toggled: annotationVisibility.cutsites,
      isOpen: toolBar.openItem === "cutsiteTool"
    };
  }
)(({ toolbarItemProps, toggled, isOpen, annotationVisibilityToggle }) => {
  return /* @__PURE__ */ jsx(
    ToolbarItem,
    {
      ...{
        Icon: /* @__PURE__ */ jsx(Icon, { "data-test": "cutsiteHideShowTool", icon: "cut" }),
        onIconClick: function() {
          annotationVisibilityToggle("cutsites");
        },
        toggled,
        tooltip: "Show cut sites",
        tooltipToggled: "Hide cut sites",
        Dropdown: CutsiteToolDropDown,
        dropdowntooltip: (!isOpen ? "Show" : "Hide") + " Cut Site Options",
        ...toolbarItemProps
      }
    }
  );
});
function CutsiteToolDropDown({
  editorName,
  toggleDropdown,
  annotationVisibilityShow,
  withDigestTool,
  createNewDigest,
  ...rest
}) {
  return /* @__PURE__ */ jsxs("div", { className: "veToolbarCutsiteFilterHolder", children: [
    /* @__PURE__ */ jsxs("h6", { children: [
      "Filter Cut Sites",
      " ",
      /* @__PURE__ */ jsx("span", { style: { fontSize: 12, color: "grey" }, children: "(Search by name or # of cuts)" })
    ] }),
    /* @__PURE__ */ jsx(
      CutsiteFilter,
      {
        ...pick(rest, userDefinedHandlersAndOpts),
        editorName,
        onChangeHook: function() {
          annotationVisibilityShow("cutsites");
        },
        closeDropDown: () => toggleDropdown({ forceClose: true })
      }
    ),
    withDigestTool && /* @__PURE__ */ jsx(
      Button,
      {
        onClick: () => {
          createNewDigest();
          toggleDropdown();
        },
        children: /* @__PURE__ */ jsxs("span", { style: { display: "flex" }, children: [
          "Virtual Digest \xA0 ",
          /* @__PURE__ */ jsx(KeyCombo, { minimal: true, combo: "mod+shift+d" })
        ] })
      }
    )
  ] });
}
